<script setup>
import AdminLayout from "@/components/LayOuts/AdminLayout";
import LoginLayout from "@/components/LayOuts/LoginLayout";
import {useRoute} from "vue-router";
import {computed} from "vue";
const route = useRoute()
// eslint-disable-next-line vue/return-in-computed-property
const layout = computed( () => {
  if (route.meta.layout == 'admin') {
    return AdminLayout
  } else {
    return LoginLayout
  }
})
</script>
<template>
  <component
      v-if="layout"
      :is="layout"
  >
    <router-view></router-view>
  </component>
</template>
<style>
.nav-item .active{background-color:#494e53 !important;}
.nav-icon{width:20px;height:20px;margin:0}
.default-icon{
  width:28px;
  height:28px;
  color: #484848;
}
.success-icon--white{
  width:40px;
  height:40px;
  color: #fff;
}
.toggle-menu{
  display: none;
}
@media only screen and (max-width : 760px) {
  .toggle-menu{
    display: block;
  }
}
.btn{min-height: 40px !important;}
.btn-send{
  font-size: 24px;
  background-color: #80b5d3 !important;
  color:#fff !important;
  padding:15px 0 !important;
  transition: 0.3s;
  width:300px;
  height:60px;
}
.btn-send:hover{
  background-color: #69a7ca !important;
}
.card-info.card-outline{
  border-top: 3px solid #80b5d3 !important;
}
a.black-link:link    {color:#000; text-decoration:none; }
a.black-link:active  {color:#000; text-decoration:none; }
a.black-link:visited {color:#000; text-decoration:none; }
a.black-link:hover   {color:#7e7e7e; text-decoration:none; }

a.card-link:link    {color:#000; text-decoration:none; }
a.card-link:active  {color:#000; text-decoration:none; }
a.card-link:visited {color:#000; text-decoration:none; }
a.card-link:hover   {color:#797979; text-decoration:none;
}

:-webkit-input-placeholder  {color:#91918e;}
::-moz-placeholder          {color:#91918e;}
:-moz-placeholder           {color:#91918e;}
:-ms-input-placeholder      {color:#91918e;}

input, textarea { outline:none; }
input:active, textarea:active { outline:none; }
:focus { outline:none; }
.number{
  display: flex;
  align-items:center;
  justify-content:center;
  text-align:center;
  width:50px;
  height:50px;
  border:3px solid #80b5d3;
  border-radius:50%;
  margin: 0 auto;
  color: #80b5d3;
  font-size: 22px;
  font-weight: bold;
}
.v-line{
  width:3px;
  height:40px;
  background-color: #80b5d3;
  margin: 0 auto;
}
</style>
